import { getItemWebStorage, setItemSessionStorage } from "../../../../features/webStorageSaver"
import { setHighContrastModeIsEnabled, setPrintButtonIsClicked } from "../../../../stateManagement/reducers/ContentHeaderSlice"
import { setAddToFavouriteModalIsShown } from "../../../../stateManagement/reducers/FavouritesSlice"
import { store } from "../../../../stateManagement/store"

export function controlMapSettingsButton(navigate: any) {
    navigate('/app/mapSettings/map')
}

export function controlHighContrastModeButton() {
    const highContrastModeIsEnabled = store.getState().contentHeader.highContrastModeIsEnabled
    const { auxiliaryLayersDisplayState } = getItemWebStorage("mapSettings") ?? {}
    const { indorAvia: indorAviaLayerIsShown, bing: bingLayerIsShown } = auxiliaryLayersDisplayState ?? {}
    if (!indorAviaLayerIsShown && !bingLayerIsShown) {
        setItemSessionStorage('mapHighContrastModeIsEnabled', !highContrastModeIsEnabled)
        store.dispatch(setHighContrastModeIsEnabled(!highContrastModeIsEnabled))
    }
}

export function controlPrintButton() {
    store.dispatch(setPrintButtonIsClicked(true))
}

export function controlAddToFavouriteButton() {
    const addToFavouriteModalIsShown = store.getState().favourites.addToFavouriteModalIsShown
    store.dispatch(setAddToFavouriteModalIsShown(!addToFavouriteModalIsShown))
}